// extracted by mini-css-extract-plugin
module.exports = {"PhotoTitleEditForm__submitBtn":"iu_a bhb_rm","PhotoTitleEditForm__cancelBtn":"iu_b bhb_rq bhb_rp"};